<ng-select
  [formControl]="control"
  [typeahead]="typing$"
  [items]="items"
  [bindLabel]="bindLabel || 'fullName'"
  [bindValue]="bindValue"
  [multiple]="true"
  [clearable]="false"
  [searchable]="true"
>
</ng-select>
